export const validateNSendContact = async ({
  token,
  email,
  message,
  phone,
  name,
}) => {
  // Use $fetch (not useFetch): this runs client-side from the submit handler, so the browser
  // sends the same-origin HTTP-only `authToken` cookie to the Nitro route, which forwards it as a
  // Bearer token to cld-core (so an authenticated visitor's userId reaches the API). useFetch is
  // SSR-aware and can run during render where that cookie is not forwarded -> anonymous request.
  const data = await $fetch("/api/validateTurnstileNSendContact", {
    method: "POST",
    body: { token, email, message, phone, name },
    retry: 1,
  });
  return data;
};
